import { render, staticRenderFns } from "./View.vue?vue&type=template&id=fe8a2fa6&"
import script from "./View.ts?vue&type=script&lang=js&"
export * from "./View.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports